import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { tryCurrentUser } from '../store/Auth';
import { authSelector } from '../store';
import Loading from '../components/UI/loading';
import Allroute from '../route';
import axios from 'axios';
import { ErrorBoundary } from 'react-error-boundary';
import ErrorFallBack from '../components/ErrorFallBack';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { getCurrentAccountInfo } from '../store/Account';
import NiceModal from '@ebay/nice-modal-react';

axios.defaults.withCredentials = true;

const _host = window.location.host;
let host;
if (_host.match(/lvh.me/)) {
  host = 'lvh.me:3000';
} else if (_host.match(/sageterminal.com/)) {
  host = 'sageterminal.com';
} else if (_host.match(/seinterminal.com/)) {
  host = 'seinterminal.com';
} else if (_host.match(/seinterminal.dev/)) {
  host = 'seinterminal.dev';
} else if (_host.match(/sagetechnologypartners.com/)) {
  host = 'sagetechnologypartners.com';
}
let subSplits = _host.split('.');
let sub;
if (subSplits.length > 2) {
  sub = subSplits[0];
  host = `${sub}.api.${host}`;
} else {
  host = `api.${host}`;
}

axios.defaults.baseURL = `//${host}`;

const errorHandler = (error: Error, errorInfo: { componentStack: string }) => {
  console.log(error, errorInfo);
};

const queryClient = new QueryClient();

function App() {
  const dispatch = useDispatch();
  const { loading, isLoggedIn } = useSelector(authSelector);

  useEffect(() => {
    dispatch(tryCurrentUser());
    if (isLoggedIn) {
      dispatch(getCurrentAccountInfo());
    }
  }, [isLoggedIn, dispatch]);

  if (loading) {
    return <Loading loadingText='Loading' />;
  }

  return (
    <ErrorBoundary fallback={<ErrorFallBack />} onError={errorHandler}>
      <QueryClientProvider client={queryClient}>
        <NiceModal.Provider>
          <Allroute />
        </NiceModal.Provider>
      </QueryClientProvider>
    </ErrorBoundary>
  );
}

export default App;
